<template>
  <section class="news-subscribe">
    <div class="">
      <div class="content">
        <div class="image">
          <img src="~/assets/images/sibscribe_block_img.svg" alt="Cosmoscow News Interface" />
        </div>
        
        <div class="info">
          <h2 class="title">{{ t('news.subscribe.title') }}</h2>
          
          <div class="sections">
            <div class="subscription-wrapper">
              <div class="email">
                <div class="section-label">{{ t('news.subscribe.email') }}</div>


                <!-- <b-input-group class="subscribe-form">
                  <b-form-input
                    v-model="email"
                    type="email"
                    :placeholder="t('news.subscribe.placeholder')"
                  />
                  <div class="input-group-append">
                    <b-button @click="handleSubmit" variant="dark" squared>
                      <Icon icon="ph:arrow-right" width="24" height="24" class="text-white" />
                    </b-button>
                  </div>
                </b-input-group> -->

                <NewsSubscriptionInput 
                  class="subscribe-form" 
                  btn_icon="ph:arrow-right"
                  :btn_text="null"
                  btn_variant="dark"
                />


              </div>

              <div class="social">
                <div class="section-label">{{ t('news.subscribe.social') }}</div>
                <div class="social-links">
                  <a 
                    v-for="link in socialLinks" 
                    :key="link.icon"
                    :href="link.url"
                    class="social-link"
                    :class="{ 'social-link--vk': link.badge }"
                    target="_blank"
                    rel="noopener"
                    :aria-label="t(link.labelKey)"
                  >
                    <Icon :icon="link.icon" :width="link.badge ? 44 : 24" :height="link.badge ? 44 : 24" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { Icon } from '@iconify/vue'
import { useI18n } from 'vue-i18n'
import NewsSubscriptionInput from '@/components/site/NewsSubscriptionInput.vue'

const { t } = useI18n({
  messages: {
    ru: {
      news: {
        subscribe: {
          title: 'Новости Cosmoscow там, где вам удобно',
          email: 'На вашей почте',
          social: 'В соцсетях',
          placeholder: 'Введите ваш email'
        }
      },
      social: {
        telegram: 'Telegram канал Cosmoscow',
        vk: 'Группа VK Cosmoscow'
      }
    },
    en: {
      news: {
        subscribe: {
          title: 'Cosmoscow News where it\'s convenient for you',
          email: 'In your email',
          social: 'Social media',
          placeholder: 'Enter your email'
        }
      },
      social: {
        telegram: 'Cosmoscow Telegram Channel',
        vk: 'Cosmoscow VK Group'
      }
    }
  }
})

const email = ref('')

const socialLinks = [
  { 
    icon: 'bxl:telegram', 
    url: 'https://t.me/cosmoscowfair', 
    labelKey: 'social.telegram'
  },
  {
    icon: 'simple-icons:vk',
    url: 'https://vk.com/cosmoscowfair',
    labelKey: 'social.vk',
    badge: true
  }
]

const handleSubmit = () => {
  // Handle form submission
  console.log('Submitted email:', email.value)
}
</script>

<style scoped lang="scss">
.news-subscribe {
  --padding-block: 0rem;
  --gap: 3.75rem;
  --form-height: 3rem;
  --border-radius: 0.5rem;
  --transition: 0.2s ease;
  --background: #F8F8F8;
  
  width: 100%;
  padding: var(--padding-block) 0;

  .container {
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    //padding: 0 20px;

    @media (max-width: 1399px) {
      //padding: 0 16px;
    }
  }

  .content {
    width: 100%;
    display: grid;
    grid-template-columns: 480px 1fr;
    gap: var(--gap);
    align-items: center;
    background: var(--background);
    border-radius: 2rem 2rem 0 0;
    padding: 3.75rem 3.75rem 0;

    @media (max-width: 1399px) {
      grid-template-columns: 400px 1fr;
      gap: 3rem;
      padding: 3rem 3rem 0;
    }

    @media (max-width: 1199px) {
      grid-template-columns: 360px 1fr;
      gap: 2.5rem;
      padding: 2.5rem 2.5rem 0;
    }

    @media (max-width: 990px) {
      grid-template-columns: 1fr;
      gap: 32px;
      padding: 2rem 1.5rem 0;
    }

    @media (max-width: 48rem) {
      text-align: center;
      padding: 2rem 1.25rem;
    }
  }

  .image {
    width: 100%;
    max-width: 480px;

    @media (max-width: 1399px) {
      max-width: 400px;
    }
    
    @media (max-width: 990px) {
      max-width: 320px;
      margin: 0 auto;
      order: 2;
    }

    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }

  .info {
    width: 100%;
    max-width: 600px;

    @media (max-width: 1399px) {
      max-width: 520px;
    }

    @media (max-width: 990px) {
      max-width: 100%;
      order: 1;
    }
  }

  .title {
    font-size: 2.5rem;
    margin-bottom: 2.5rem;
    font-weight: 700;

    @media (max-width: 1399px) {
      font-size: 2.25rem;
      margin-bottom: 2.25rem;
    }

    @media (max-width: 1199px) {
      font-size: 2rem;
      margin-bottom: 2rem;
    }

    @media (max-width: 990px) {
      font-size: 1.75rem;
      margin-bottom: 1.75rem;
      text-align: center;
    }

    @media (max-width: 48rem) {
      font-size: 1.5rem;
      margin-bottom: 1.5rem;
    }
  }

  .sections {
    display: flex;
    flex-direction: column;
    gap: 2.5rem;

    @media (max-width: 1399px) {
      gap: 2.25rem;
    }

    @media (max-width: 1199px) {
      gap: 2rem;
    }

    @media (max-width: 990px) {
      gap: 1.75rem;
      align-items: center;
    }
  }

  .subscription-wrapper {
    display: flex;
    align-items: flex-end;
    gap: 2rem;

    @media (max-width: 990px) {
      flex-direction: column;
      align-items: center;
      gap: 1.5rem;
    }
  }

  .email {
    flex: 1;
    min-width: 0;
  }

  .social {
    flex-shrink: 0;

    @media (max-width: 990px) {
      width: 100%;
    }

    .section-label {
      @media (max-width: 990px) {
        text-align: center;
      }
    }
  }

  :deep(.subscribe-form) {
    width: 100%;
    max-width: 400px;

    @media (max-width: 1399px) {
      max-width: 380px;
    }

    @media (max-width: 1199px) {
      max-width: 100%;
    }

    @media (max-width: 990px) {
      max-width: 400px;
      margin: 0 auto;
    }

    .input-group {
      border-radius: 10rem;
      background: #fff;
      border: 1px solid rgba(0, 0, 0, 0.1);
    }

    .form-control {
      height: var(--form-height);
      border: 1px solid #E0E0E0;
      font-size: 1rem;
      padding: 0 1.5rem;
      background: transparent;
      border-radius: 0.7rem 0 0 0.7rem !important;
      color: #000;

      &::placeholder {
        color: rgba(0, 0, 0, 0.4);
      }

      &:focus {
        outline: none;
        box-shadow: none;
      }
    }

    .btn {
      height: var(--form-height);
      min-width: 4rem;
      padding: 0;
      display: grid;
      place-items: center;
      border: none;
      background: #000;
      border-radius: 0rem 0.7rem 0.7rem 0rem !important;
      margin: -1px;
      transition: background var(--transition);
      z-index: 2;
      color: #fff;

      :deep(svg) {
        color: #fff;
      }

      &:hover, &:focus {
        background: #333;
      }

      &:focus {
        box-shadow: none;
      }
    }

    .input-group-append {
      margin-left: 0;
    }
  }

  .social-links {
    display: flex;
    gap: 1rem;
    
    @media (max-width: 990px) {
      justify-content: center;
    }
  }

  .social-link {
    width: var(--form-height);
    height: var(--form-height);
    display: grid;
    place-items: center;
    background: #000;
    border-radius: 50%;
    color: #fff;
    transition: background var(--transition);
    flex-shrink: 0;

    &:hover {
      background: #333;
    }
  }

  .social-link--vk {
    background: transparent;
    color: #000;

    &:hover {
      background: transparent;
      opacity: 0.8;
    }
  }
}

.section-label {
  font-size: 1.2rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #000;

  @media (max-width: 990px) {
    text-align: center;
  }
}
</style>
